import { Audio } from "@abcya/abcya_phaser";
import Gator from "../game/Gator";
import gameData from "../gameData";
import NavBar from "../ui/NavBar";
import UIAssetKeys from "../UIAssetKeys";

export default class PlayScene extends Phaser.Scene
{
    static get KEY() { return 'PlayScene'; }

    create()
    {
		this.bg = null;

		this.next = null;
		this.prev = null;

		this.gators = [];
		this.allGators = null;
		this.activeGators = null;
		this.navBar = null;

		this.page = null;

		gameData.gameOver = false;
		gameData.gamePaused = false;
		gameData.currentScene = "playScene";
		// gameData.currentLevel = 5; // Enable for single scene testing
		// gameData.time = 5000000; // 60

		gameData.time = 60;
		gameData.score = 0;

		Audio.playOneShot("later_gator_jingle", this, .3, true);

		this.bg = this.add.sprite(0,0, gameData.ss, UIAssetKeys._BackgroundLargerGutter).setOrigin(0);
		this.navBar = new NavBar(this);
		this.add.existing(this.navBar);

		this.navBar.on('Paused', ()=>{
			for(let each in this.activeGators)
			{
				if(this.activeGators[each]?.timer) this.activeGators[each].timer.paused = true;
			}
		})

		this.navBar.on('Unpause', ()=>{
			for(let each in this.activeGators)
			{
				if(this.activeGators[each]?.timer) this.activeGators[each].timer.paused = false;
			}
		})

		this.createGators();
	}

	createGators() {
		this.gators = [];
		this.allGators = [];
		this.activeGators = [];
		let dir;

		for(let g=0; g<6; g++){
			if(g === 0 || g === 2 || g === 4){
				dir = "left";
			} else {
				dir = "right";
			}

			const gator = new Gator(this, dir, g);
			this.add.existing(gator);

			this.gators.push(gator);
			this.allGators.push(gator);
		}

		if(gameData.currentLevel === 1 || gameData.currentLevel === 2){
			this.newGator();
			this.time.addEvent({
				delay: 200,                
				callback: ()=>this.newGator(),
			});
		}
		else if(gameData.currentLevel === 3){
			this.newGator();
			this.time.addEvent({
				delay: 200,                
				callback: ()=>this.newGator(),
			});
			this.time.addEvent({
				delay: 700,                
				callback: ()=>this.newGator(),
			});
		}
		else if(gameData.currentLevel === 4){
			this.newGator();
			this.time.addEvent({
				delay: 200,                
				callback: ()=>this.newGator(),
			});
			this.time.addEvent({
				delay: 700,                
				callback: ()=>this.newGator(),
			});
			this.time.addEvent({
				delay: 1200,                
				callback: ()=>this.newGator(),
			});
		}
		else if(gameData.currentLevel === 5){
			this.newGator();
			this.time.addEvent({
				delay: 200,                
				callback: ()=>this.newGator(),
			});
			this.time.addEvent({
				delay: 700,                
				callback: ()=>this.newGator(),
			});
			this.time.addEvent({
				delay: 1200,                
				callback: ()=>this.newGator(),
			});
			this.time.addEvent({
				delay: 1700,                
				callback: ()=>this.newGator(),
			});
		}
	};

	newGator() {
		if(!gameData.gameOver && this.activeGators.length < (gameData.currentLevel + 1)){
			if(gameData.currentLevel === 1 || gameData.currentLevel === 2) Phaser.Utils.Array.Shuffle(this.gators);
			this.checkVerbs();
			//console.log('new gator', this.activeGators.length);
			this.gators[0].burstOut();
			this.activeGators.push(this.gators[0]);
			this.gators.shift();
		}
	};

	checkVerbs = function () {
		if(gameData.rightAnswer === false){
			this.gators[0].changeText(gameData.nounType);
			this.gators[0].isCorrect = true;
			gameData.rightAnswer = true;
		} else {
			if(gameData.nounType === "singular"){
				this.gators[0].changeText("plural");
			} else {
				this.gators[0].changeText("singular");
			}
		}
	};

	allHide() {

		gameData.rightAnswer = false;

		for(let g=0; g<this.activeGators.length; g++){
			this.activeGators[g].hide();
			this.activeGators[g].isCorrect = false;
		}
	};

	cleanUp = function () {
		// game.tweens.removeAll();
		// game.sound.stopAll();

		this.bg.destroy();

		this.state.start("PlayScene");
	};
}
/*

	me.

	me.cleanUp = function () {
		game.tweens.removeAll();
		game.sound.stopAll();

		this.bg.destroy();

		game.state.start("PlayScene");
	};

	me.update = function () {

	};

	/* RENDER 
	me.render = function () {

	};
})();*/